import Box from '@material-ui/core/Box';
import { styled } from '@material-ui/core/styles';

export const StyledBulkEmailDetails = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));
